import { cn } from "@/lib/utils";

interface ProfileTagProps {
  text: string;
  className?: string;
}

export function ProfileTag({ text, className }: ProfileTagProps) {
  return (
    <div className={cn("px-1.5 bg-white rounded-[4px] w-fit text-primary border border-light-grey rounded-[400px]", className)}>
      <p className="paragraph-10">{text}</p>
    </div>
  )
}